import React from 'react';
import { Loader2 } from 'lucide-react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useIsMobile } from '../../hooks/useIsMobile';
import { useLoginViewModel } from './viewModel';
import { LoginView } from './views';

export function LoginPage() {
  const { currentUser, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useIsMobile();
  const redirect = new URLSearchParams(location.search).get('redirect');
  const vm = useLoginViewModel(
    () => navigate(redirect || '/app'),
    isMobile ? 'redirect' : 'popup',
  );

  if (authLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (currentUser) {
    return <Navigate to={redirect || '/app'} replace />;
  }

  return <LoginView vm={vm} />;
}
